<template>
	<div class="single-full single-flex-row">
		<div class="mh-days text-align">
			<p class="right-td td-element-center">{{result.totalWorkingDays}}</p>
		</div>
		<div class="mh-vac">
			<p class="right-td td-element-center">{{result.vacations}}</p>
		</div>
		<div class="mh-sick">
			<p class="right-td td-element-center">{{result.sick}}</p>
		</div>
		<div class="mh-other">
			<p class="right-td td-element-center">{{result.other}}</p>
		</div>
		<div class="note-t mh-act">
			<p class="right-td td-element-center">{{result.actualWorkingDays}}</p>
		</div>
		<div class="right-td mh-note"></div>
		<div class="tv">
			<p
				class="right-td has-tooltip td-element-center left-days-cell-i"
				data-original-title="null"
				:class="daysLeftClass"
			>{{result.engaged}}%</p>
		</div>
	</div>
</template>

<script>
    export default {
        name: "WorkLoadResult",
        props: ["result"],
        computed: {
            metadata: function () {
                return this.$store.state.reports.consultantWorkloadMetadata;
            },
            daysLeftClass: function () {
                let metadata = this.metadata;
                if (
                    parseInt(this.result.engaged) >=
                    parseInt(metadata.consultantWorkloadGreen)
                ) {
                    return "blue";
                } else if (
                    parseInt(this.result.engaged) >=
                    parseInt(metadata.consultantWorkloadRed) &&
                    parseInt(this.result.engaged) <
                    parseInt(metadata.consultantWorkloadGreen)
                ) {
                    return "yellow";
                } else {
                    return "red";
                }
            }
        }
    };
</script>

<style scoped>
	.text-align {
		text-align: center;
	}

	td.right-td {
		line-height: 23px;
		padding-top: 8.5px !important;
		padding-bottom: 8.5px !important;
	}

	.each-month tr:first-of-type td {
		padding-top: 0 !important;
	}

	/* edited  */
	/* .mh-days {
										  min-width: 62px !important;
										  max-width: 62px !important;
										  width: 62px !important;
										}

										.mh-vac,
										.mh-sick {
										  min-width: 44px !important;
										  max-width: 44px !important;
										  width: 44px !important;
										}

										.mh-other,
										.mh-act {
										  min-width: 57px !important;
										  max-width: 57px !important;
										  width: 57px !important;
										}


										.mh-act{
										    min-width: 41px !important;
										    max-width: 41px !important;
										    width: 41px !important;
										}


										.mh-other {
										  padding-left: 15px;
										} */

	.single-full {
		width: 100%;
	}
	/* 
										.note-t.mh-act p{
										  width: 28px;
										  text-align: center;
										}

										.tv p{
										  min-width: 55px !important;
										  margin-left: 5px;
										} */

	/* new styles  */
	.mh-days {
		min-width: 62px !important;
		max-width: 62px !important;
		width: 62px !important;
	}

	.mh-vac,
	.mh-sick {
		min-width: 44px !important;
		max-width: 44px !important;
		width: 44px !important;
	}

	.mh-other {
		min-width: 50px !important;
		max-width: 50px !important;
		width: 50px !important;
	}

	.mh-act {
		min-width: 42px !important;
		max-width: 42px !important;
		width: 42px !important;
	}

	.tv {
		min-width: 75px !important;
		max-width: 75px !important;
		width: 75px !important;
	}

	/* Making element center */
	.each-moth-bottom .mh-vac .td-element-center,
	.each-moth-bottom .mh-sick .td-element-center,
	.each-moth-bottom .mh-other .td-element-center,
	.each-moth-bottom .mh-act .td-element-center {
		text-align: center;
	}

	.tv .td-element-center {
		max-width: 55px;
		margin: 0 auto;
	}
</style>